export const ICONS_SIZES = {
  SIZE_10: `--icons-size-10`,
  SIZE_20: `--icons-size-20`,
  SIZE_30: `--icons-size-30`,
  SIZE_40: `--icons-size-40`,
  SIZE_50: `--icons-size-50`,
} as const
export type ICONS_SIZES = (typeof ICONS_SIZES)[keyof typeof ICONS_SIZES]

export const NoContentIconSizes = {
  DEFAULT: '--icon-sizes-nocontent-default',
} as const
export type NoContentIconSizes =
  (typeof NoContentIconSizes)[keyof typeof NoContentIconSizes]
